// src/app/core/constants/api-endpoints.ts
export const API_ENDPOINTS = {
  auth: {
    login: 'login',
    forgotPassword: 'forgot-password',
    resetpassword: 'reset-password',
    changePassword: 'change-password',
    refreshToken: 'refresh-token'
  },
  employer: {
    list: 'employers',
    create: 'create-employer',
    update: 'update-employer',
    details: (id: string) => `employer/${id}`,
    agents: 'employer/agents',
    commissions: 'employer/agent/commissions',
    attachAgent: 'employer/attach-agent',
    dropdown: 'employers/minimal',
    delete: 'delete-employer',
    parent_dropdown: 'employers/parentminimal',
    employerAgents: (id: string) => `attach-agent?employer_id=${id}`,
    employerAgent: (employer_id: string, agent_id: string) => `employer-agent?employer_id=${employer_id}&agent_id=${agent_id}`
  },
  agent: {
    list: 'agents',
    create: 'create-user',
    update: 'update-user',
    delete: 'delete-user',
    dropdown: 'agents/minimal',
    details: (id: string) => `/agent/${id}`,
    employers: (id: string) => `agent-employers?id=${id}`

  },
  admin: {
    list: 'users',
    create: 'create-user',
    update: 'update-user',
    delete: 'delete-user',
    details: (id: string) => `user/${id}`,
  },
  user: {
    profile: 'profile',
    changePassword: 'profile-change-password',
    updateProfile: 'profile',
  },
  actuals: {
    list: 'payrolls',
    add: 'add',
    createPayroll: 'create-payroll',
    updatePayroll: 'update-payroll',
    confirmPayroll: (id: string) => `confirm-payroll/${id}`,
    downloadPayroll: (id: string) => `download-payroll/${id}`,
    details: (id: string) => `payroll/${id}`
  },
  commissions: {
    adminEmployerCommission: 'v1/agent-employers-commissions',
    adminSubEmployerCommission: 'v1/agent-subemployers-commissions/',
    adminEmployeeCommission: 'v1/employee-commissions/',
    list: 'v1/all_commissions',
    add: 'add',
    agentCommission: 'agent-employers-commissions',
  },
  plans: 'plans'
};